<template>
  <div>
    <div class="card mb-2">
      <div class="card-header px-2 py-2 d-flex justify-content-between align-items-center">
        <h5 class="d-flex align-items-center font-weight-bold text-muted mb-0">
          <button
            class="btn btn-link text-muted font-weight-bold p-0 header-btn"
            @click="ui.show = !ui.show"
          >
            Location
          </button>
          <button
            type="button"
            class="btn btn-link btn-sm ml-2 p-0"
            @click="removeAllRules"
            :disabled="$props.disabled || $props.value.length === 0"
          >
            Delete Rules
          </button>
        </h5>
      </div>
      <div
        v-show="ui.show"
        class="card-body px-2 py-2"
      >
        <div class="form-row">
          <div
            v-if="error.show"
            class="col"
          >
            <div class="alert alert-danger px-2 py-2">
              <p class="font-weight-bold mb-0">
                {{ error.title }}
              </p>
              <p class="mb-0">
                {{ error.msg }}
              </p>
            </div>
          </div>
          <div class="col-12 mb-2">
            <label
              for="property-location"
              class="text-truncate d-block small mb-0"
            >Property Location</label>
            <vue-typeahead-bootstrap
              :data="search.locationResults"
              v-model="search.locationQuery"
              placeholder="Type to search for a location"
              :disabled="ui.locationDisabled || $props.disabled"
              :disabled-sort="true"
              :show-all-results="true"
              :show-on-focus="true"
              @input="locationSearch"
              @hit="locationSearchSelect"
              :serializer="item => item.DisplayName"
              :class="{
                'w-rule-none': !hasLocationUpdateRule,
                'w-rule-add': hasLocationUpdateRule
              }"
            >
              <template slot="append">
                <button
                  type="button"
                  class="btn btn-xs p-0 m-0 btn-rule-reset-address"
                  title="Remove Rule"
                  v-if="hasLocationUpdateRule"
                  :disabled="$props.disabled"
                  @click="removeLocationRule"
                >
                  <i class="jam jam-close-circle-f" />
                </button>
                <button
                  type="button"
                  class="btn btn-outline-primary btgn-sm"
                  @click="ui.locationDisabled = !ui.locationDisabled"
                  :disabled="$props.disabled"
                  style="width:75px;"
                >
                  {{ ui.locationDisabled ? 'Unlock' : 'Lock' }}
                </button>
              </template>
            </vue-typeahead-bootstrap>
          </div>
        </div>
        <div
          v-show="showMapSection"
          class="form-row mt-2"
        >
          <div class="col-12">
            <div class="form-row">
              <div class="col-6">
                <div
                  id="map-address"
                  class="map"
                  v-text="`Map Not Loaded`"
                />
              </div>
              <div class="col-6">
                <label
                  for="property-address"
                  class="text-truncate d-block small mb-0"
                >Property Address</label>
                <div class="position-relative">
                  <input
                    id="property-location"
                    class="form-control has-clear"
                    :class="{
                      'rule-none': !hasAddressUpdateRule,
                      'rule-add': hasAddressUpdateRule
                    }"
                    name="Address"
                    :value="values.Address"
                    :disabled="$props.disabled"
                    placeholder="Carrer de Thomas Alva Edison, 7, 46980 Paterna, Valencia"
                    @input="updateAttribute"
                  >
                  <button
                    type="button"
                    class="btn btn-xs p-0 m-0 btn-rule-reset"
                    title="Remove Address Rule"
                    v-if="hasAddressUpdateRule"
                    :disabled="$props.disabled"
                    @click="removeAttributeRule('Address')"
                  >
                    <i class="jam jam-close-circle-f" />
                  </button>
                  <small v-if="map.formattedAddress">{{ map.formattedAddress }} (From Google)</small>
                </div>
              </div>
            </div>
            <div class="form-row mt-1">
              <div class="col-6">
                <div
                  id="map-coordinates"
                  class="map"
                  v-text="`Map Not Loaded`"
                />
              </div>
              <div class="col-6">
                <div class="form-row">
                  <div class="col-6">
                    <label class="text-truncate d-block small mb-0">Latitude</label>
                    <div class="position-relative">
                      <input
                        type="number"
                        :value="values.Latitude"
                        class="form-control has-clear"
                        :class="{
                          'rule-none': !hasLatitudeUpdateRule,
                          'rule-add': hasLatitudeUpdateRule
                        }"
                        placeholder="39.552183266319716"
                        @input="updateAttribute"
                        name="Latitude"
                      >
                      <button
                        type="button"
                        class="btn btn-xs p-0 m-0 btn-rule-reset"
                        title="Remove Latitude Rule"
                        v-if="hasLatitudeUpdateRule"
                        :disabled="$props.disabled"
                        @click="removeAttributeRule('Latitude')"
                      >
                        <i class="jam jam-close-circle-f" />
                      </button>
                    </div>
                  </div>
                  <div class="col-6">
                    <label class="text-truncate d-block small mb-0">Longitude</label>
                    <div class="position-relative">
                      <input
                        type="number"
                        :value="values.Longitude"
                        :class="{
                          'rule-none': !hasLongitudeUpdateRule,
                          'rule-add': hasLongitudeUpdateRule
                        }"
                        class="form-control has-clear"
                        placeholder="-0.464292130688113"
                        name="Longitude"
                        @input="updateAttribute"
                      >
                      <button
                        type="button"
                        class="btn btn-xs p-0 m-0 btn-rule-reset"
                        title="Remove Longitude Rule"
                        v-if="hasLongitudeUpdateRule"
                        :disabled="$props.disabled"
                        @click="removeAttributeRule('Longitude')"
                      >
                        <i class="jam jam-close-circle-f" />
                      </button>
                    </div>
                  </div>
                </div>
                <label class="mb-1 mt-1 font-weight-bold">The location is:</label>
                <div class="position-relative">
                  <div
                    :class="{
                      'form-check pl-4': true,
                      'rule-none': !hasGeoInfoUpdateRule,
                      'rule-add': hasGeoInfoUpdateRule
                    }"
                  >
                    <input
                      class="form-check-input"
                      type="radio"
                      name="GeoInfo"
                      value="exact"
                      :checked="values.GeoInfo === 'exact'"
                      @input="updateAttribute"
                    >
                    <label class="form-check-label">Exact location of the property</label>
                  </div>
                  <div
                    :class="{
                      'form-check pl-4': true,
                      'rule-none': !hasGeoInfoUpdateRule,
                      'rule-add': hasGeoInfoUpdateRule
                    }"
                  >
                    <input
                      class="form-check-input"
                      type="radio"
                      name="GeoInfo"
                      value="street"
                      :checked="values.GeoInfo === 'street'"
                      @input="updateAttribute"
                    >
                    <label class="form-check-label">The Street where the property is located</label>
                  </div>
                  <div
                    :class="{
                      'form-check pl-4': true,
                      'rule-none': !hasGeoInfoUpdateRule,
                      'rule-add': hasGeoInfoUpdateRule
                    }"
                  >
                    <input
                      class="form-check-input"
                      type="radio"
                      name="GeoInfo"
                      value="approx"
                      :checked="values.GeoInfo === 'approx'"
                      @input="updateAttribute"
                    >
                    <label class="form-check-label">Approximate location of the property</label>
                  </div>
                  <div
                    :class="{
                      'form-check pl-4': true,
                      'rule-none': !hasGeoInfoUpdateRule,
                      'rule-add': hasGeoInfoUpdateRule
                    }"
                  >
                    <input
                      class="form-check-input"
                      type="radio"
                      name="GeoInfo"
                      value="town"
                      :checked="values.GeoInfo === 'town'"
                      @input="updateAttribute"
                    >
                    <label class="form-check-label">The City/Town where the property is located</label>
                  </div>
                  <div
                    :class="{
                      'form-check pl-4': true,
                      'rule-none': !hasGeoInfoUpdateRule,
                      'rule-add': hasGeoInfoUpdateRule
                    }"
                  >
                    <input
                      class="form-check-input"
                      type="radio"
                      name="GeoInfo"
                      :value="null"
                      :checked="values.GeoInfo === null || values.GeoInfo === ''"
                      @input="updateAttribute"
                    >
                    <label class="form-check-label">Not Specified</label>
                  </div>
                  <button
                    type="button"
                    class="btn btn-xs p-0 m-0 btn-rule-reset"
                    title="Remove GeoInfo Rule"
                    id="geoInfoClear"
                    v-if="hasGeoInfoUpdateRule"
                    :disabled="$props.disabled"
                    @click="removeAttributeRule('GeoInfo')"
                  >
                    <i class="jam jam-close-circle-f" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
    makeLocationRule,
    RuleKeyLocationUpdate,
    makeLocationAttributeRule,
    RuleKeyAttributeUpdate
} from '../rules/location';

import { RuleScopeProperty } from '../consts';

export default {
    data: () => ( {
        initialLocation: '',
        ui: {
            show: true,
            locationDisabled: true,
            mapScriptLoaded: false
        },
        map: {
            address: null,
            addressMarker: null,
            coordinates: null,
            coordinatesMarker: null,
            loaded: false,
            formattedAddress: null
        },
        search: {
            locationQuery: '',
            locationResults: []
        },
        error: {
            show: false,
            msg: '',
            title: ''
        },
        inputClasses: {
            Address: {
                ruleNone: true,
                ruleAdd: false
            },
            Location: {
                ruleNone: true,
                ruleAdd: false
            },
            GeoInfo: {
                ruleNone: true,
                ruleAdd: false
            },
            Latitude: {
                ruleNone: true,
                ruleAdd: false
            },
            Longitude: {
                ruleNone: true,
                ruleAdd: false
            }
        },
        values: {
            Address: '',
            GeoInfo: '',
            Latitude: '',
            Longitude: ''
        }
    } ),
    computed: {
        hasLocationUpdateRule() {
            return this.$props.value.some( rule => rule.key === RuleKeyLocationUpdate );
        },
        hasAddressUpdateRule() {
            return this.$props.value.some( rule => rule.key === RuleKeyAttributeUpdate && rule.name === 'Address' );
        },
        hasGeoInfoUpdateRule() {
            return this.$props.value.some( rule => rule.key === RuleKeyAttributeUpdate && rule.name === 'GeoInfo' );
        },
        hasLatitudeUpdateRule() {
            return this.$props.value.some( rule => rule.key === RuleKeyAttributeUpdate && rule.name === 'Latitude' );
        },
        hasLongitudeUpdateRule() {
            return this.$props.value.some( rule => rule.key === RuleKeyAttributeUpdate && rule.name === 'Longitude' );
        },
        showMapSection() {
            return ( ( this.values.Latitude && this.values.Longitude ) || this.values.Address );
        }
    },
    methods: {
        validate() {
            let state = {
                valid: true,
                msg: ''
            };

            return state;
        },
        removeAttributeRule( name ) {
            let rules = this.$props.value;
            rules = rules.filter( rule => {
                if ( rule.key === RuleKeyAttributeUpdate && rule.name === name ) {
                    return false;
                }
                return true;
            } );
            this.values[ name ] = this.$props.property[ name ];
            this.inputClasses[ name ].ruleAdd = false;
            this.inputClasses[ name ].ruleNone = true;
            this.$emit( 'input', rules );
        },
        showMap() {
            const initMap = () => {
                const addressContainer = document.getElementById( 'map-address' );
                const coordinatesContainer = document.getElementById( 'map-coordinates' );

                if ( this.map.coordinates === null && this.values.Latitude && this.values.Longitude ) {
                    this.map.coordinates = new window.google.maps.Map( coordinatesContainer, {
                        zoom: 7,
                        zoomControl: true,
                        mapTypeControl: false,
                        scaleControl: false,
                        streetViewControl: false,
                        rotateControl: false,
                        fullscreenControl: false
                    } );
                }

                if ( this.values.Latitude && this.values.Longitude ) {
                    const pos = {
                        lat: this.values.Latitude,
                        lng: this.values.Longitude
                    };

                    this.map.coordinates.setCenter( pos );

                    if ( this.map.coordinatesMarker === null ) {
                        this.map.coordinatesMarker = new window.google.maps.Marker( {
                            map: this.map.coordinates
                        } );
                    }

                    this.map.coordinatesMarker.setPosition( pos );
                }

                if ( this.map.address === null && this.values.Address && this.values.Address.length > 0 ) {
                    this.map.address = new window.google.maps.Map( addressContainer, {
                        zoom: 12,
                        zoomControl: true,
                        mapTypeControl: false,
                        scaleControl: false,
                        streetViewControl: false,
                        rotateControl: false,
                        fullscreenControl: false
                    } );
                }

                if ( this.values.Address && this.values.Address.length > 0 ) {
                    const geocoder = new window.google.maps.Geocoder();

                    const onResponse = ( results, status ) => {
                        if ( status !== window.google.maps.GeocoderStatus.OK ) {
                            this.error.title = 'Address Search Failed';
                            this.error.msg = `Google search failed for the property address with status: "${status}"`;
                            this.error.show = true;
                            addressContainer.classList.add( 'hide-map' );
                            return;
                        }

                        if ( status === window.google.maps.GeocoderStatus.ZERO_RESULTS ) {
                            this.error.title = 'No Address Found';
                            this.error.msg = 'No results found for that property address. Likely cause is that is incorrect or is too vague.';
                            this.error.show = true;
                            addressContainer.classList.add( 'hide-map' );
                            return;
                        }

                        if ( results.length > 1 ) {
                            this.error.title = 'Multiple Address Found';
                            this.error.msg = 'Mutliple results have been found for the address provided. This is most likely caused by a incomplete adddress/too vague.';
                            this.error.show = true;
                        }

                        const pos = {
                            lat: results[ 0 ].geometry.location.lat(),
                            lng: results[ 0 ].geometry.location.lng()
                        };

                        this.map.address.setCenter( pos );

                        if ( this.map.addressMarker === null ) {
                            this.map.addressMarker = new window.google.maps.Marker( {
                                position: pos,
                                map: this.map.address,
                                title: this.values.Address
                            } );
                        }

                        this.map.addressMarker.setPosition( pos );

                        this.map.formattedAddress = `${results[ 0 ].formatted_address} (${pos.lat}, ${pos.lng})`;
                    };

                    geocoder.geocode( {
                        'address': this.values.Address
                    }, onResponse );
                }
            };

            if ( document.getElementById( 'googleMapsAPI' ) || this.ui.mapScriptLoaded ) {
                initMap();
                return;
            }

            const script = document.createElement( 'script' );
            script.id = 'googleMapsAPI';
            script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.GOOGLE_MAPS_KEY}`;
            script.onload = initMap;
            document.head.appendChild( script );
            this.ui.mapScriptLoaded = true;
        },
        async getLocation( type, id ) {
            const url = `${process.env.LOCATIONS_API_URL}/${type}/${id}`;
            return await fetch( url, {
                headers: {
                    'Authorization': `Bearer ${this.$store.state.token}`
                }
            } );
        },
        async locationSearch() {
            if ( this.search.locationQuery.length === 0 ) {
                return;
            }

            const url = `${process.env.LOCATIONS_API_URL}/location?freetext=${this.search.locationQuery}&lang=en`;

            const locationResponse = await fetch( url, {
                headers: {
                    'Authorization': `Bearer ${this.$store.state.token}`
                }
            } );

            if ( locationResponse.status !== 200 ) {
                return;
            }

            let locations = await locationResponse.json();
            locations = locations.filter( location => location.Type === 'town' );

            this.search.locationResults = locations;
        },
        locationSearchSelect( selectedLocation ) {
            this.error.show = false;

            this.ui.location = selectedLocation;
            this.ui.locationDisabled = true;

            this.inputClasses[ 'Location' ].ruleAdd = true;
            this.inputClasses[ 'Location' ].ruleNone = false;

            const locationKey = `${selectedLocation.Type}:${selectedLocation.ID}`;

            const result = makeLocationRule( {
                location: locationKey,
                key: RuleKeyLocationUpdate,
                createdBy: this.$store.getters.email,
                scope: RuleScopeProperty
            } );

            if ( result.error !== null ) {
                this.error.msg = result.error.toString();
                this.error.show = true;
            }

            const rules = this.value.filter( rule => rule.key !== RuleKeyLocationUpdate );
            rules.push( result.rule );
            this.$emit( 'input', rules );
            this.ui.locationDisabled = true;
        },
        reset() {
            this.ui = this.initialState;
            this.map.formattedAddress = null;
            this.setState();
        },
        removeAllRules() {
            this.$emit( 'input', [] );
        },
        removeLocationRule() {
            let rules = this.$props.value;
            rules = rules.filter( rule => rule.key !== RuleKeyLocationUpdate );
            this.$emit( 'input', rules );
            this.search.locationQuery = this.initialLocation;
        },
        updateAttribute( event ) {
            this.error.show = false;

            const attributeName = event.target.name;
            let attributeValue = null;

            switch ( event.target.type ) {
            case 'text':
                attributeValue = event.target.value;

                if ( attributeValue === null || typeof attributeValue === 'undefined' ) {
                    attributeValue = '';
                }
                break;
            case 'number':
                attributeValue = event.target.valueAsNumber;

                if ( !attributeValue && attributeValue !== 0 ) {
                    attributeValue = null;
                }
                break;
            }

            this.inputClasses[ attributeName ].ruleAdd = true;
            this.inputClasses[ attributeName ].ruleNone = false;

            const result = makeLocationAttributeRule( {
                name: attributeName,
                value: attributeValue,
                key: RuleKeyAttributeUpdate,
                createdBy: this.$store.getters.email,
                scope: RuleScopeProperty
            } );

            if ( result.error !== null ) {
                this.error.msg = result.error.toString();
                this.error.show = true;
                return;
            }

            this.values[ attributeName ] = attributeValue;
            this.addRule( result.rule );
        },
        addRule( rule ) {
            let rules = this.value.filter( r => r.name !== rule.name );
            rules.push( rule );
            this.$emit( 'input', rules );
        },
        fetchRelevantPropertyLocation() {
            const property = this.$props.property;

            if ( !property.Town && !property.Province && !property.Region && !property.Coast ) {
                return;
            }

            let selectedLocation = null;

            if ( property.Town ) {
                selectedLocation = property.Town;
            } else if ( property.Province ) {
                selectedLocation = property.Province;
            } else if ( property.Region ) {
                selectedLocation = property.Region;
            }

            this.search.locationQuery = selectedLocation.Labels.Default;
            this.initialLocation = selectedLocation.Labels.Default;
        },
        toggleLocation() {
            if ( !this.hasLocationUpdateRule ) {
                this.ui.locationDisabled = false;
                return;
            }
        },
        async setState() {
            this.fetchRelevantPropertyLocation();

            this.values.Address = this.$props.property.Address;
            this.values.GeoInfo = this.$props.property.GeoInfo;
            this.values.Longitude = this.$props.property.Longitude;
            this.values.Latitude = this.$props.property.Latitude;

            const addressRule = this.$props.value.find( rule => rule.key === RuleKeyAttributeUpdate && rule.name === 'Address' );

            if ( addressRule ) {
                this.values.Address = addressRule.value;
            }

            const geoInfoRule = this.$props.value.find( rule => rule.key === RuleKeyAttributeUpdate && rule.name === 'GeoInfo' );

            if ( geoInfoRule ) {
                this.values.GeoInfo = geoInfoRule.value;
            }

            const latitudeRule = this.$props.value.find( rule => rule.key === RuleKeyAttributeUpdate && rule.name === 'Latitude' );

            if ( latitudeRule ) {
                this.values.Latitude = latitudeRule.value;
            }

            const longitudeRule = this.$props.value.find( rule => rule.key === RuleKeyAttributeUpdate && rule.name === 'Longitude' );

            if ( longitudeRule ) {
                this.values.Longitude = longitudeRule.value;
            }

            if ( this.hasLocationUpdateRule ) {
                const rule = this.$props.value.find( rule => rule.key === RuleKeyLocationUpdate );
                const keyParts = rule.location.split( ':' );
                const type = keyParts[ 0 ];
                const id = keyParts[ 1 ];

                const locationResponse = await this.getLocation( type, id );

                const data = await locationResponse.json();

                if ( locationResponse.status !== 200 ) {
                    this.error.msg = data;
                    this.error.title = `Failed to fetch location with key "${rule.location}"`;
                    this.error.show = true;
                } else {
                    this.search.locationQuery = data.Labels.Default;
                }
            }

            if ( ( this.values.Latitude && this.values.Longitude ) || this.values.Address ) {
                this.showMap();
            }
        }
    },
    async mounted() {
        this.initialState = this.ui;
        await this.setState();
    },

    props: {
        property: {
            required: false,
            type: Object,
            default: () => ( { } )
        },
        value: {
            required: false,
            type: Array,
            default: () => []
        },
        disabled: {
            required: true,
            type: Boolean,
            default: () => false
        }
    }
};
</script>
<style scoped>
.map {
  text-align: center;
  padding-top: 50%;
  background-color: rgb(229, 227, 223);
}

.map.hide-map > div {
  display: none;
}

#btn-rule-reset-address {
  position: absolute;
  right: 90px;
}

#addressClear {
  right: 140px;
}

#geoInfoClear {
  right: 5px;
  top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/property-qc/handlers/LocationRuleHandler.vue